export const ENROLLMENT_VERIFY_PHONE = 'ENROLLMENT_VERIFY_PHONE';

export const enrollmentVerifyPhone = payload => dispatch =>
  dispatch({
    type: ENROLLMENT_VERIFY_PHONE,
    payload,
  });
